import { Feature } from '@tencent/workbench';
import { EventEmitter as EventBus } from '@src/slide/infrastructure/module/independent/event-emitter';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';

// 菜单名字
export const enum MENU_NAME {
    FILE = 'file',
    EDIT = 'edit',
    PLAY = 'play',
    DISABLED = 'disabled',
}

export enum MenuBarEventsKeys {
    ACTIVE_BTN_CHANGE  = 'active-btn-change'
}
export interface MenuBarEventsMap {
    [MenuBarEventsKeys.ACTIVE_BTN_CHANGE]: MENU_NAME;
}

@Feature()
export class MenuBarFeature extends BaseTitleBarFeature {
    public event = new EventBus<MenuBarEventsMap>();
    private activeMenu: MENU_NAME | undefined; // 被点击的按钮
    private isAutoExpandDropdown: boolean; // 是否自动展开下拉菜单
    private showDisableMask: boolean;

    public constructor() {
        super();
        // 初始化事件
        this.registerListener();
    }

    // 更新被点击的menu
    public updateActiveMenu = (name?: MENU_NAME) => {
        if (this.showDisableMask) {
            return;
        }
        this.activeMenu = name;
        this.event.emit(MenuBarEventsKeys.ACTIVE_BTN_CHANGE, name);
    };

    public getActiveMenu = () => this.activeMenu;

    // 自动打开和关闭下来菜单状态
    public toggleAutoExpandDropdownStatus(bool: boolean) {
        if (this.showDisableMask) {
            return;
        }
        this.isAutoExpandDropdown = bool;
    }

    // 更新被点击的menu
    public mouseEnter = (name: MENU_NAME) => {
        // 如果自动展开下拉菜单的状态是关闭的，就直接返回吧
        if (!this.isAutoExpandDropdown) {
            return ;
        }
        this.updateActiveMenu(name);
    };

    private registerListener = () => {
        this.getAppServices().editableServiceLayer?.historyManager.on('show', () => {
            this.updateActiveMenu(MENU_NAME.DISABLED);
            this.showDisableMask = true;
            this.isAutoExpandDropdown = false;
        });
        this.getAppServices().editableServiceLayer?.historyManager.on('hide', () => {
            this.showDisableMask = false;
            this.updateActiveMenu(undefined);
        });
    };
}
